import { useTranslation } from "react-i18next";

const rows = [1, 2, 3, 4, 5, 6];

export default function ComparisonTable() {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto rounded-lg border border-background-200 bg-background-50">
      <table className="w-full min-w-[420px] text-sm">
        <thead>
          <tr className="bg-primary-500 text-background-50">
            <th className="px-4 py-3 text-left font-semibold">{t("compare.colFeature")}</th>
            <th className="px-4 py-3 text-left font-semibold">{t("compare.colA")}</th>
            <th className="px-4 py-3 text-left font-semibold">{t("compare.colB")}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((i) => (
            <tr key={i} className="border-t border-background-200">
              <td className="px-4 py-3 font-medium text-foreground-800">{t(`compare.row${i}.f`)}</td>
              <td className="px-4 py-3 text-primary-700">{t(`compare.row${i}.a`)}</td>
              <td className="px-4 py-3 text-foreground-600">{t(`compare.row${i}.b`)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}